export default "__VITE_ASSET__9e19400f__"